import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import "primereact/resources/primereact.min.css";

function HfnAccordion(props) {
  const { Title, Panel } = props;
  return (
    <div className={`hfnaccordion_wrapper ${Title}_wrapper`}>
      <Accordion>
        {Panel?.map((item) => {
          return (
            <AccordionTab
              key={item?.id}
              header={item?.Title && parse(item?.Title)}
            >
              {item?.Description && parse(item?.Description)}
            </AccordionTab>
          );
        })}
      </Accordion>
    </div>
  );
}

HfnAccordion.propTypes = {
  /**
   * Title is wrapper for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * Panel is actual list of data for component
   * */
  Panel: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      Title: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default HfnAccordion;
